import { render } from "./BlogPost.vue?vue&type=template&id=0048eb76&scoped=true"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=0048eb76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0048eb76"]])

export default __exports__